import { Descriptions } from "antd";
import React from "react";
import { knownAllergiesOptions } from "../../../../IpEMR/Options/historyOptions";
import { getLabelTagsWithDescription } from "../../../../IpEMR/InspectionSummaries/constructTextFromValues";

const KnownAllergies = ({ data }) => {
  return (
    <div>
      <Descriptions bordered={false}>
        <Descriptions.Item>
          {data && getLabelTagsWithDescription(knownAllergiesOptions, data)}
        </Descriptions.Item>
      </Descriptions>
    </div>
  );
};

export default KnownAllergies;
